export default "__VITE_ASSET__zG3_RG4P__"